import type { RouteRecordRaw } from 'vue-router';

import discoverListRoute from './discover-list';

export default [discoverListRoute] as RouteRecordRaw[];
